module.exports = __webpack_public_path__ + "img/food_pack.df4f5369.png";